import React, { useState } from 'react';
import TrueFalseExercise from './TrueFalseExercise';
import './TrueFalseExerciseBoard.css';

const TRUE_FALSE_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)', marginRight: 20
  }}>
    <svg width="28" height="28" viewBox="0 0 34 34" fill="white">
      <g>
        <g>
          <path d="m30 15h-6v1c0 2.8-2.2 5-5 5h-7v8c0 1.7 1.3 3 3 3h15c1.7 0 3-1.3 3-3v-11c0-1.7-1.3-3-3-3zm-2.3 6.7-6 6c-.2.2-.4.3-.7.3s-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.3 2.3 5.3-5.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4z"/>
        </g>
        <g>
          <path d="m19 2h-15c-1.7 0-3 1.3-3 3v11c0 1.7 1.3 3 3 3h15c1.7 0 3-1.3 3-3v-11c0-1.7-1.3-3-3-3zm-3.4 11.2c.4.4.4 1 0 1.4s-1 .4-1.4 0l-2.7-2.7-2.7 2.7c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l2.7-2.7-2.7-2.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.7 2.7 2.7-2.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-2.7 2.7z"/>
        </g>
      </g>
    </svg>
  </span>
);

const TrueFalseExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  // Поддерживаем оба формата: questions (старый) и statements (новый)
  const questions = exerciseData.questions || exerciseData.statements || [];
  const { title, level } = exerciseData;

  if (!questions || !Array.isArray(questions)) {
    return (
      <div className="true-false-board-error">
        <p>Error: Invalid True/False exercise data</p>
      </div>
    );
  }

  return (
    <div className="true-false-exercise-board">
      {!isExpanded ? (
        <div
          className={`true-false-preview unified-exercise-preview tf-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {TRUE_FALSE_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'True/False Exercise'}</div>
            <div className="unified-preview-meta">
              {questions.length} questions · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="true-false-expanded">
          <TrueFalseExercise
            statements={questions}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default TrueFalseExerciseBoard; 